import { Badge, type BadgeTone } from '@safetyhub/ui';
import type { StoryCheckStatus } from '../../lib/stories';
import { statusLabel, STATUS_HINTS, STATUS_TONE } from './storyMonitorView';

/**
 * 스토리·판정 상태 배지 — 목록·명세별 표·상세가 **같은 매핑**을 쓴다.
 *
 * ## ⚠️ `null`은 중립색이고 «초록이 아니다»
 * 「판정 없음」(결과 0건)을 `PASS`와 같은 색으로 그리면 **아무것도 안 잰 것이 통과로 보인다** —
 * 이 화면이 막으려는 바로 그 오독이다. 그래서 색·라벨을 둘 다 가른다.
 *
 * `title`은 `Badge`의 prop이 아니라 감싸는 `span`이 쥔다(`BadgeProps`에 그 칸이 없고, 공용
 * 프리미티브에 도메인용 prop을 늘리지 않는 것이 그 패키지의 규약이다).
 */
export default function StoryStatusBadge({
  status,
  size,
}: {
  status: StoryCheckStatus | null;
  size?: 'sm' | 'md';
}) {
  const tone: BadgeTone = status === null ? 'slate' : STATUS_TONE[status];
  return (
    <span title={STATUS_HINTS[status ?? 'null']} className="inline-flex">
      <Badge tone={tone} size={size} dot>
        {statusLabel(status)}
      </Badge>
    </span>
  );
}
